module.exports = __webpack_public_path__ + "img/leagal.5eb62369.svg";